export default [
    {
      title: 'Survey',
      customIcon: 'Survey',
      children: [
        {
          title: 'Survey List',
          route: 'custom-module',
          path: '/custom-module/survey',
        },
      ],
    },
  ];